import type { GetStaticProps, InferGetStaticPropsType } from 'next';

import { StaticSeoHomepage, type StaticSeoHomepageProps } from '@/components/public-site/StaticSeoHomepage';
import { loadStaticHomepageMessages } from '@/lib/seo/static-homepage-data';

export const getStaticProps: GetStaticProps<StaticSeoHomepageProps> = async () => ({
  props: {
    locale: 'zh',
    messages: await loadStaticHomepageMessages('zh'),
  },
  revalidate: 600,
});

export default function ChineseHomepage(
  props: InferGetStaticPropsType<typeof getStaticProps>,
) {
  return <StaticSeoHomepage {...props} />;
}
